import { createSlice } from '@reduxjs/toolkit'

import {
  initialReferralsImportState,
  reducers,
  ReferralsImportState,
} from '@/redux/slices/referralsImportBase'

const INITIAL_STATE: ReferralsImportState = {
  ...initialReferralsImportState,
}

const referralsImportNew = createSlice({
  name: 'referralsImportNew',
  initialState: INITIAL_STATE,
  reducers,
})

export const referralsImportNewReducer = referralsImportNew.reducer

export const {
  setIsOpen,
  setImportItems,
  updateImportItem,
  removeImportItem,
  setStep,
  setOnClientDuplicate,
  updateImportItemStatus,
  selectItems,
  bulkUpdateImportItems,
} = referralsImportNew.actions
